import { recordPageAction } from 'newrelic/newrelic-telemetry'

/**
 * Auth startup diagnostics for New Relic PageAction.
 *
 * A blank main panel while auth.initialized stays false looks like an outage to
 * users but leaves almost no signal in JS errors alone. These events mark the
 * specific failure modes we have seen in prod: no resolvable session, init errors,
 * and long stalls behind AuthInitializedGate.
 */

export const reportAuthNoUserSession = (trigger = 'unknown', extra = {}) => {
  recordPageAction('auth_no_user_session', { trigger, ...extra })
}

export const reportAuthProcessError = (message, phase = 'unknown') => {
  recordPageAction('auth_process_error', {
    message: String(message || 'unknown').slice(0, 200),
    phase,
  })
}

export const reportAuthInitStalled = path => {
  recordPageAction('auth_init_stalled', { path: path || '' })
}

export const reportAuthInitFailed = (message, phase = 'unknown') => {
  recordPageAction('auth_init_failed', {
    message: String(message || 'unknown').slice(0, 200),
    phase,
  })
}
